// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"J4-z","colorTextValue":"K4-z","swatches":"L4-z","collapseLink":"M4-z","isCollapsed":"N4-z","dropdown":"O4-z","disabled":"P4-z"};